import { render, staticRenderFns } from "./show_result.html?vue&type=template&id=3a4eb906&scoped=true&"
import script from "./show_result.js?vue&type=script&lang=js&"
export * from "./show_result.js?vue&type=script&lang=js&"
import style0 from "./show_result.scss?vue&type=style&index=0&id=3a4eb906&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a4eb906",
  null
  
)

export default component.exports